"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var range = function range(start, end) {
  return Array.from({
    length: end - start
  }, function (v, k) {
    return k + start;
  });
};
var _default = exports["default"] = range(1, 92).map(function (num) {
  return {
    value: "".concat(num),
    name: "error_codes.".concat(num)
  };
});